import PriceRowAgentHubCommission from 'agentHub/components/PriceRowAgentHubCommission'
import FormatCurrency from 'components/Common/FormatCurrency'
import CruisesDiscountTsAndCsModal from 'components/Cruises/CruisesDiscountTsAndCsModal'
import PriceRowCaption from 'LuxKit/PricePoints/PriceRowCaption'
import PriceRowPrice from 'LuxKit/PricePoints/PriceRowPrice'
import PriceRowPriceCaption from 'LuxKit/PricePoints/PriceRowPriceCaption'
import PriceRowTaxesAndFees from 'LuxKit/PricePoints/PriceRowTaxesAndFees'
import PriceRowValueDiscountWithCaption from 'LuxKit/PricePoints/Value/PriceRowValueDiscountWithCaption'
import ModalContext from 'contexts/ModalContext'
import type { CruiseOfferView } from 'hooks/Cruise/useCruiseOfferView'
import useCruiseSelectedCabinType from 'hooks/useCruiseSelectedCabinType'
import React, { useCallback, useContext } from 'react'

interface Props {
  view: CruiseOfferView
}

function CruiseSearchTilePricing({ view }: Props) {
  const {
    lowestPrice,
    discountPills,
  } = view

  const selectedCabinType = useCruiseSelectedCabinType(view.cruiseType)

  const showModal = useContext(ModalContext)

  const openDiscountTermsAndConditionsModal = useCallback(() => {
    showModal(<CruisesDiscountTsAndCsModal />)
  }, [showModal])

  return <div>
    {selectedCabinType && <PriceRowPriceCaption>{selectedCabinType} from</PriceRowPriceCaption>}
    {!selectedCabinType && <PriceRowPriceCaption>From</PriceRowPriceCaption>}
    {lowestPrice && <PriceRowPrice
      size="L"
      price={lowestPrice.primaryPrice.total}
      saleUnit={lowestPrice.primaryPrice.type}
    />}
    {lowestPrice?.secondaryPrice && <PriceRowCaption>
      <FormatCurrency value={lowestPrice.secondaryPrice.total} /> /{lowestPrice.secondaryPrice.type} · Twin Share
    </PriceRowCaption>}
    {!lowestPrice?.secondaryPrice && discountPills?.price && discountPills.discountPercentage && <PriceRowValueDiscountWithCaption
      size="M"
      originalValue={discountPills.price}
      discountPercentage={discountPills.discountPercentage}
      onInfoIconClick={openDiscountTermsAndConditionsModal}
    />}
    {!lowestPrice?.secondaryPrice && <PriceRowCaption>Twin Share</PriceRowCaption>}
    <PriceRowTaxesAndFees />
    <PriceRowAgentHubCommission
      offerId={view.offer.id}
      offer={view.offer}
      productType={view.offer.productType}
    />
  </div>
}

export default CruiseSearchTilePricing
